import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "CarParkService",
  controller: "CarParkRecord",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemList",
  "GetCarParkById",
  "FindByConditions",
  "GetItemPagingList",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const CarParkRecordApi = ZJApi.defineNewApi("CarParkRecordApi", factory);

export default CarParkRecordApi;
